module.exports = __webpack_public_path__ + "img/cooperative0_logo8.95a31bef.jpg";